/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsRestartAodRunRunActionsMutationResponse, AuditReportsRestartAodRunRunActionsPathParams, AuditReportsRestartAodRunRunActions401, AuditReportsRestartAodRunRunActions403, AuditReportsRestartAodRunRunActions404 } from "../models/AuditReportsRestartAodRunRunActions";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { auditReportsRestartAodRunRunActions } from "../axios/auditReportsRestartAodRunRunActions";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const auditReportsRestartAodRunRunActionsMutationKey = () => [{ url: '/audit-reports/v1/aod-runs/:id/restart' }] as const

export type AuditReportsRestartAodRunRunActionsMutationKey = ReturnType<typeof auditReportsRestartAodRunRunActionsMutationKey>

export function auditReportsRestartAodRunRunActionsMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = auditReportsRestartAodRunRunActionsMutationKey()
        return mutationOptions<AuditReportsRestartAodRunRunActionsMutationResponse, ResponseErrorConfig<AuditReportsRestartAodRunRunActions401 | AuditReportsRestartAodRunRunActions403 | AuditReportsRestartAodRunRunActions404>, {id: AuditReportsRestartAodRunRunActionsPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return auditReportsRestartAodRunRunActions(id, config)
          },
        })

}

/**
 * @description Resets the run to WAITING, deletes its report, and re-enqueues processing. Allowed from COMPLETED_WITH_EXPORT, COMPLETED_WITHOUT_EXPORT, or FAILED.
 * @summary Restart a run
 * {@link /audit-reports/v1/aod-runs/:id/restart}
 */
export function useAuditReportsRestartAodRunRunActions<TContext>(options: 
{
  mutation?: UseMutationOptions<AuditReportsRestartAodRunRunActionsMutationResponse, ResponseErrorConfig<AuditReportsRestartAodRunRunActions401 | AuditReportsRestartAodRunRunActions403 | AuditReportsRestartAodRunRunActions404>, {id: AuditReportsRestartAodRunRunActionsPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? auditReportsRestartAodRunRunActionsMutationKey()

          const baseOptions = auditReportsRestartAodRunRunActionsMutationOptions(config) as UseMutationOptions<AuditReportsRestartAodRunRunActionsMutationResponse, ResponseErrorConfig<AuditReportsRestartAodRunRunActions401 | AuditReportsRestartAodRunRunActions403 | AuditReportsRestartAodRunRunActions404>, {id: AuditReportsRestartAodRunRunActionsPathParams["id"]}, TContext>
          

          return useMutation<AuditReportsRestartAodRunRunActionsMutationResponse, ResponseErrorConfig<AuditReportsRestartAodRunRunActions401 | AuditReportsRestartAodRunRunActions403 | AuditReportsRestartAodRunRunActions404>, {id: AuditReportsRestartAodRunRunActionsPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AuditReportsRestartAodRunRunActionsMutationResponse, ResponseErrorConfig<AuditReportsRestartAodRunRunActions401 | AuditReportsRestartAodRunRunActions403 | AuditReportsRestartAodRunRunActions404>, {id: AuditReportsRestartAodRunRunActionsPathParams["id"]}, TContext>
      
}